import { formatISO, startOfDay } from 'date-fns';
import { defaults, filter, get, isEmpty, isInteger, isNull, map, omitBy, round, startsWith } from 'lodash';
import { configSettings } from 'src/config';
import { isArraysEqual, isDate, isEmptyValue } from 'src/utils/check';
import { round5, roundMoney, transToSnakeCase, valueToInteger, valueToNumber } from 'src/utils/parse';
export const carTypeFlex = 'flex';
export const carTypeFix = 'fix';
export const bookingFindCarTabs = {
  carFind: {
    value: 'car-find',
    label: 'Tìm xe'
  },

  carResponse: {
    value: 'car-response',
    label: 'Chờ phản hồi'
  }
};

export const headerHeight = 37;
export const enableResize = {
  top: false,
  right: true,
  bottom: false,
  left: false,
  topRight: false,
  bottomRight: false,
  bottomLeft: false,
  topLeft: false
};

export const defaultAddress = {
  address: 'Ho Chi Minh City, Vietnam',
  lat: 10.8230989,
  lng: 106.6296638
};
export const defaultGeocodingKey = transToSnakeCase(defaultAddress.address);

export const defaultMapDestination = {
  destinations: [defaultAddress.address, ''],
  destinationsGeocoding: { [defaultGeocodingKey]: { lat: defaultAddress.lat, lng: defaultAddress.lng } }
};

export const BookingCheckModel = (data) => {
  let cleanData = omitBy(data, isNull) || {};

  if (isDate(cleanData?.start)) {
    cleanData.start = formatISO(new Date(cleanData.start)); // Chuyển sang ISO 8601
  }

  if (isDate(cleanData?.end)) {
    cleanData.end = formatISO(new Date(cleanData.end)); // Chuyển sang ISO 8601
  }

  return defaults(cleanData, {
    id: null,
    start: formatISO(startOfDay(new Date())), // Mặc định ngày hiện tại theo ISO 8601
    end: '',
    days: 1,
    ...defaultMapDestination,
    distance: 0,
    distanceArising: 0,
    tollFeePerKm: 2000,
    coefficient: 1,
    orderCost: 0,
    weekend: false,
    fixWeekend: false,
    driverSelfSuff: get(configSettings, 'driver_self_suff.value'),
    twoway: get(configSettings, 'twoway.value'),
    vatFlag: get(configSettings, 'vat_flag.value')
  });
};
const calculateCost = (fee, coefficient) => {
  return fee * coefficient;
};

export const calcBookingPrice = (baseFees, conditions, settings) => {
  let result = [];
  if (conditions.length === 0) {
    return result;
  }

  const weekend = conditions['weekend'] || conditions['fixWeekend'];
  const distance2Way = conditions['distance'] * 2;
  const days = conditions['days'] - 1;
  const petrolPrice = valueToInteger(settings[configSettings.petrol_price.key].value);
  const vatPercent = valueToInteger(settings[configSettings.vat_percent.key].value);
  let coefficient = valueToNumber(conditions['coefficient']);
  coefficient = coefficient < 0 ? 0 : coefficient;
  console.log('calcBookingPrice vatPercent', vatPercent);
  map(baseFees, (baseFee) => {
    const departureCost = calculateCost(baseFee['departure'], baseFee['departureCoeff']);
    const byDayCost = calculateCost(baseFee['byday'], baseFee['bydayCoeff']) * days;
    const weekendCost = weekend ? calculateCost(baseFee['weekend'], baseFee['weekendCoeff']) : 0;
    const tollCost = valueToInteger(conditions['tollFeePerKm']) * distance2Way;
    const driverCost = calculateCost(baseFee['driverCost'], baseFee['driverCostCoeff']) * conditions['days'];
    const driverSelfCost = conditions['driverSelfSuff'] && conditions['days'] > 1 ? calculateCost(baseFee['driverSelfSuff'], days) : 0;
    let fuelCost = baseFee['fuelConsumption'] * petrolPrice * (distance2Way / 100);
    fuelCost = round(fuelCost);
    const distanceArisingCost = baseFee['fuelConsumption'] * petrolPrice * (conditions['distanceArising'] / 100);
    const orderCost = valueToInteger(conditions['orderCost']);

    let total =
      (departureCost + byDayCost + weekendCost + tollCost + driverCost + driverSelfCost + fuelCost + distanceArisingCost + orderCost) *
      coefficient;

    total = total * (conditions['twoway'] == true ? 1 : baseFee['onewayCoeff']);

    const totalRounded = roundMoney(total);

    let vatCost = conditions['vatFlag'] == true ? (totalRounded / 100) * vatPercent : 0;
    vatCost = round(vatCost);

    result.push({
      id: baseFee.id,
      name: baseFee.name,
      total: totalRounded + vatCost,
      details: [
        {
          name: 'Tổng',
          cost: totalRounded
        },
        {
          name: 'Xuất bến',
          cost: departureCost
        },
        {
          name: 'Qua ngày',
          cost: byDayCost
        },
        {
          name: 'Cuối tuần',
          cost: weekendCost
        },
        {
          name: 'Cầu đường',
          cost: tollCost
        },
        {
          name: 'Tài xế',
          cost: driverCost
        },
        {
          name: 'Tài xế tự túc',
          cost: driverSelfCost
        },
        {
          name: 'Xăng dầu',
          cost: fuelCost
        },
        {
          name: 'Km phát sinh',
          cost: distanceArisingCost
        },
        {
          name: `VAT ( ${vatPercent} %)`,
          cost: vatCost
        },
        {
          name: 'Khác',
          cost: orderCost
        }
      ]
    });
  });
  return result;
};

export const roundDistance = (distance) => {
  if (distance <= 50) {
    return 50;
  }
  return round5(distance);
};

export const filterCar = (options) => {
  const listSeat = filter(options, function (value) {
    return isInteger(value);
  });

  if (listSeat) {
    let filerOptions = options;
    listSeat.map((value) => {
      filerOptions = filter(filerOptions, (option) => startsWith(option, `${value}-`));
    });
    return filerOptions;
  }

  return options;
};

export const getMapDesinations = (destinations, geocodings) => {
  if (!isEmpty(destinations)) {
    const results = [];
    map(destinations, (destination, index) => {
      if (!isEmptyValue(destination)) {
        const key = transToSnakeCase(destination);
        const geocoding = get(geocodings, key, {});
        if (!isEmpty(geocoding)) {
          results.push({
            index: index,
            address: destination,
            ...geocoding
          });
        }
      }
    });

    return results;
  }

  return [];
};

export const getFormDesination = (destinations) => {
  if (!isEmpty(destinations)) {
    let results = {
      destinations: [],
      destinationsGeocoding: {}
    };
    map(destinations, ({ address, lat, lng }) => {
      if (!isEmptyValue(address)) {
        results.destinations.push(address);
        const key = transToSnakeCase(address);
        results.destinationsGeocoding = {
          ...results.destinationsGeocoding,
          [key]: {
            lat,
            lng
          }
        };
      }
    });

    return results;
  }

  return {};
};

export const groupByOwned = (results) => {
  const groupedData = {};

  map(results, (result) => {
    const { ownedBy, ...carInfo } = result;

    if (!groupedData[ownedBy.id]) {
      groupedData[ownedBy.id] = {
        ...ownedBy,
        cars: []
      };
    }

    groupedData[ownedBy.id].cars.push(carInfo);
  });

  return Object.values(groupedData);
};

export const checkAllDeninedBooking = (request) => {
  const denined = request.denined ?? [];
  const to = request.sendTo ?? [];
  if (isArraysEqual(denined, to)) {
    return true;
  }
  return false;
};
